import './styles/main.scss';
import React from "react";
import { BrowserRouter, Routes, Route} from "react-router-dom";
import Header from "./components/Header/Header";
import HomePage from "./pages/HomePage/HomePage";
import TechPage from "./pages/TechPage/TechPage";
import Footer from './components/Footer/Footer';

function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <Header />
        <div className="main-content">
          <Routes>
            <Route exact path="/" element={<HomePage />} />
            <Route path="/TechPage" element={<TechPage />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
